import {utils, rawRenderingLib, RenderingServices} from '@wallaby-ui/core';
import classNames from 'classnames';
import {EntityLink} from 'src/js/containers/file/components/EntityLink';
import styles from 'src/js/containers/file/components/EntityLink.less';
import {EntityLinkProps} from 'src/js/containers/file/file_types';
import {baseEntityLinkParams} from 'src/js/lib/raw_rendering/base_entity_link_params';

/**
 * Returns raw DOM element version of EntityLink component.
 * @param params
 * @param services
 * @returns {Element}
 */

export default function entityLinkRenderer(params: EntityLinkProps, services: RenderingServices) {
  const {children, suppressPadding, titleText, hrefTo, isAllowed} = baseEntityLinkParams(
    params,
    services,
    utils.componentUtils.getDisplayName(EntityLink)
  );

  const spanElem = document.createElement('span');
  spanElem.className = classNames(styles.dlEntityLink, {
    [styles.dlEntityLinkLayout]: !suppressPadding,
  });
  if (isAllowed) {
    const linkElem = rawRenderingLib.reactRouterLinkRenderer({children, title: titleText, tabIndex: 0, to: hrefTo}, services);
    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(spanElem, linkElem);
  } else {
    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(spanElem, children);
  }

  return spanElem;
}
